import React from 'react';
import EditCompany from '../../components/EditCompany/EditCompany';

const Company = () => <EditCompany />;

export default Company;
